export default {
  brand: 'teba',
  name: 'Old Mutual Will',
  contactEmail: 'support@teba.oldmutualwill.co.za',
  contactTelNumber: '010 056 4927',
  contactAddress: 'Mutualpark, \nJan Smuts Drive, \nPinelands, 7405',
  contactAddressRedesign: 'Mutualpark, \nJan Smuts Drive, \nPinelands, \n7405',
  internalExecutorName: 'Old Mutual Will',
  estateAssistEnabled: true,
  landingPageBanner: 'co-branded',
  coBranded: {
    coBrandedBanner: 'teba/homepage/co_branded/co_branded_banner.svg',
    logo: 'teba/homepage/co_branded/co-branded-logo.svg',
  },
  overviewPageTitle: "Old Mutual's Online Will Service in partnership with",
  overviewPartnershipTitle: 'Teba',
  colors: {
    primary: '#00B188',
    secondary: '#F5A81C',
    'secondary-highlighted-font': '#FFFFFF',
    'secondary-button-font': '#FFFFFF',
    leftPanelGreen: '#009677',
    leftPanelIconGrey: '#DFE2EF',
    leftPanelOrange: '#FF9800',
  },
  requestACallTel: '010 056 4927',
  requestACallTelUrl: '+27100564927',
  images: {
    homepage: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Get a will',
          title: `in 25 minutes*`,
          subtitle: `Decide how to honour your legacy`,
          disclaimer:
            '*Completion time of 25 minutes is based on an average customer profile with readily available information.',
          buttonText: 'GET STARTED',
          buttonLink: 'SignUp',
        },
        {
          src: 'teba/homepage/hero_bar/home/2/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/home/2/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/home/2/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/home/2/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/home/2/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/home/2/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'GET STARTED',
          buttonLink: 'SignUp',
        },
      ],
    },
    articles: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/articles/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/articles/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/articles/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/articles/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/articles/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/articles/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    calculator: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/calculator/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/calculator/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/calculator/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/calculator/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/calculator/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/calculator/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    faqs: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/faqs/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/faqs/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/faqs/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/faqs/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/faqs/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/faqs/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    howItWorks: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/how-it-works/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/how-it-works/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/how-it-works/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/how-it-works/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/how-it-works/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/how-it-works/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    ourSolutions: {
      heroBarSourceSets: [
        {
          src: 'teba/homepage/hero_bar/our-solutions/1440.svg',
          landscapeSrc: 'teba/homepage/hero_bar/our-solutions/1440.svg',
          mobileSrc: 'teba/homepage/hero_bar/our-solutions/360.svg',
          iPadMiniSrc: 'teba/homepage/hero_bar/our-solutions/960.svg',
          srcset: [
            {
              url: 'teba/homepage/hero_bar/our-solutions/1440.svg',
              width: '1440w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/1280.svg',
              width: '1280w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/1024.svg',
              width: '1024w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/960.svg',
              width: '960w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/840.svg',
              width: '840w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/720.svg',
              width: '720w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/600.svg',
              width: '600w',
            },
            {
              url: 'teba/homepage/hero_bar/our-solutions/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    logo: null,
    homeMain: 'teba/homepage/main_header1.svg',
    mobileHomeMain: 'teba/homepage/mobile_header.svg',
    homeSteps1: 'teba/homepage/steps1.svg',
    homeSteps2: 'teba/homepage/steps2.svg',
    homeSteps3: 'teba/homepage/steps3.svg',
    homeSteps4: 'teba/homepage/steps4.svg',
    homeUsp1: 'teba/homepage/usp_icon1.svg',
    homeUsp2: 'teba/homepage/usp_icon2.svg',
    homeUsp3: 'teba/homepage/usp_icon3.svg',
    homeUsp4: 'teba/homepage/usp_icon4.svg',
    homeTestatimonial1: null,
    homeTestatimonial2: null,
    homeTestatimonial3: null,
    overviewStep1: 'teba/overview/about_yourself.svg',
    overviewStep2: 'teba/overview/people.svg',
    overviewStep3: 'teba/overview/assets.svg',
    overviewStep4: 'teba/overview/sparkly_btc.svg',
    overviewStep5: 'teba/overview/remainder1.svg',
    overviewStep6: 'teba/overview/letter_of_wishes.svg',
    overviewStep7: 'teba/overview/insurance.svg',
    aboutYourselfPage: 'teba/overview/about_yourself.svg',
    assetsPage: 'teba/overview/remainder1.svg',
    worldWideAssetsPage: 'teba/overview/remainder1.svg',
    pageNotFound: 'teba/overview/pet_bostie.svg',
    insuranceAgeRestrictedPage: 'teba/overview/charity_pig.svg',
    estimatedInsuranceRequiredPage: 'teba/insurance/insurance.svg',
    estimatedInsuranceRequiredInputPage:
      'teba/insurance/estimated-insurance-required-input.svg',
    estimatedInsuranceRequiredOutputPage:
      'teba/insurance/estimated-insurance-required-output.svg',
    getFreeInsuranceQuotePageTop:
      'teba/insurance/get-free-insurance-quote-page-top.svg',
    getFreeInsuranceQuotePageBottom:
      'teba/insurance/get-free-insurance-quote-page-bottom.svg',
    getFreeInsuranceQuotePageSmoker: 'teba/insurance/smoker.svg',
    getFreeInsuranceQuotePageNonSmoker: 'teba/insurance/non-smoker.svg',
    getFreeInsuranceQuotePageSmokerSelected:
      'teba/insurance/smoker-selected.svg',
    getFreeInsuranceQuotePageNonSmokerSelected:
      'teba/insurance/non-smoker-selected.svg',
    insuranceBankingDetailsPage: 'teba/insurance/banking-details.svg',
    insuranceExplanationPage: 'teba/insurance/explanation.svg',
    insuranceQuestionsPage: 'teba/insurance/questions.svg',
    insuranceNonSACitizenPage: 'teba/overview/charity_pig.svg',
    insuranceRequestAdvisorCallPage: 'teba/insurance/explanation.svg',
    letterOfWishesPage: 'teba/overview/letter_of_wishes.svg',
    livingWillPage: 'teba/overview/living-will.svg',
    manageAccountPage: 'teba/overview/about_yourself.svg',
    peopleOverviewPage: 'teba/overview/people.svg',
    peopleOverviewSpouse: 'teba/overview/spouse.svg',
    peopleOverviewChildren: 'teba/overview/guardian.svg',
    peopleOverviewExecutor: 'teba/overview/executor.svg',
    peopleOverviewHeir: 'teba/overview/heir.svg',
    peopleOverviewCharities: 'teba/overview/charity_box.svg',
    peopleOverviewTrusts: 'teba/overview/charity_pig.svg',
    distributionSpecificPercentageAlternativesPage:
      'teba/overview/remainder1.svg',
    assetDonationPage: 'teba/overview/assets.svg',
    moneyDonationPage: 'teba/overview/money_1.svg',
    specificDonationsPageAssets: 'teba/overview/assets.svg',
    specificDonationsPageMoney: 'teba/overview/money_1.svg',
    activateAccountPageMain:
      'teba/activation-landing-page/house_and_funeral.svg',
    activateAccountPage1: 'teba/activation-landing-page/will.svg',
    activateAccountPage2: 'teba/activation-landing-page/rand_money.svg',
    activateAccountPage3: 'teba/activation-landing-page/tombstone.svg',
    activateAccountPage4: 'teba/activation-landing-page/sold_house.svg',
    activateAccountPage5: 'teba/activation-landing-page/will_being_read.svg',
    activateAccountPage6: 'teba/activation-landing-page/executor.svg',
    executorExplainerMain: 'teba/advisor-page/quinton.svg',
    executorExplainerHowDoesItWork1: 'teba/executor/post_box.svg',
    executorExplainerHowDoesItWork2: 'teba/executor/coffin.svg',
    executorExplainerHowDoesItWork3: 'teba/executor/nomination_form.svg',
    executorExplainerHowDoesItWork4: 'teba/executor/post_box_letter.svg',
    executorExplainerEstateAdminPartner: '',
    advisorPageMain: 'teba/advisor-page/quinton.svg',
    advisorPageWhyUseUs1: 'teba/advisor-page/marketing_sharing.svg',
    advisorPageWhyUseUs2: 'teba/advisor-page/bostie_and_leash.svg',
    advisorPageWhyUseUs3: 'teba/advisor-page/scale.svg',
    advisorPageWhyUseUs4: 'teba/advisor-page/executor.svg',
    advisorPageWhyUseUs5: 'teba/advisor-page/dashboard.svg',
  },
  cssLogo: true,
  FAQUrl: '/faqs',
  blogUrl: '/articles',
  fontFamily:
    'Montserrat, Gill Sans, Gill Sans MT, Calibri, Trebuchet MS, sans-serif',
  authentication: {
    resetPassword: {
      title: 'Enter the cell number you signed up with',
      fieldTitle: 'Cell Number*',
      fieldName: 'phone',
      buttonText: 'Request Password Reset',
      validation: 'required|phone',
      validationMessage: 'The cell number field is required.',
      successMessage:
        'If you signed up with this phone number, you will receive an sms to reset your password',
    },
    login: {
      title: 'Log in',
      fieldTitle: 'Industry Number*',
      fieldName: 'unique_identifier',
      buttonText: 'Log in',
      validation: 'required',
    },
    signUp: {
      title: 'Sign up to continue...',
      showEmail: false,
      showPhone: true,
      showUniqueIdentifier: true,
    },
    invite: {
      method: 'sms',
    },
  },
  termsAndConditionsLocation: '/terms-and-conditions',
  canonicalUrls: {
    homepage: 'https://www.oldmutualwill.co.za',
    login: 'https://www.oldmutualwill.co.za/login',
    signup: 'https://www.oldmutualwill.co.za/signup',
    termsAndConditions: 'https://www.oldmutualwill.co.za/terms-and-conditions',
    competitionTermsAndConditions:
      'https://www.oldmutualwill.co.za/competition-terms-and-conditions',
    forgotPassword: 'https://www.oldmutualwill.co.za/forgot-password',
  },
  meta: {
    data: [
      {
        property: 'description',
        content:
          "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      },
      { property: 'og:title', content: 'Teba Will: Your will done your way' },
      {
        property: 'og:image',
        content: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: '/' },
      {
        property: 'og:description',
        content:
          'Protect your family by creating your legally binding will, online, in just minutes.',
      },
      { property: 'og:site_name', content: 'Teba' },
    ],
    links: {
      favicon: 'favicons/om-favicon.png',
      font: 'https://fonts.googleapis.com/css?family=Montserrat:100,300,400,500,600,700,900',
    },
    scripts: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Teba',
          url: 'https://teba.oldmutualwill.co.za',
          address: 'Mutualpark, Jan Smuts Drive, Cape Town',
          sameAs: ['https://www.facebook.com/61558538057385/'],
        },
      },
    ],
  },
  metaData: {
    howItWorks: {
      title: 'Create Your Will Online | How It Works',
      description:
        "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      ogTitle: 'Teba Will: Your will done your way',
      ogImage: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      ogType: 'website',
      ogUrl: 'https://teba.oldmutualwill.co.za/how-it-works',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Teba',
    },
    ourSolutions: {
      title: 'Create Your Will Online | Our Solutions',
      description:
        "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      ogTitle: 'Teba Will: Your will done your way',
      ogImage: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      ogType: 'website',
      ogUrl: 'https://teba.oldmutualwill.co.za/our-solutions',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Teba',
    },
    calculator: {
      title: 'Create Your Will Online | Estate Administration Cost Calculator',
      description:
        "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      ogTitle: 'Teba Will: Your will done your way',
      ogImage: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      ogType: 'website',
      ogUrl:
        'https://teba.oldmutualwill.co.za/estate-administration-cost-calculator',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Teba',
    },
    faqs: {
      title: 'Create Your Will Online | FAQs',
      description:
        "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      ogTitle: 'Teba Will: Your will done your way',
      ogImage: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      ogType: 'website',
      ogUrl: 'https://teba.oldmutualwill.co.za/faqs',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Teba',
    },
    articles: {
      title: 'Create Your Will Online | Articles',
      description:
        "Create your will online with Teba's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      ogTitle: 'Teba Will: Your will done your way',
      ogImage: 'https://teba.oldmutualwill.co.za/meta/teba.png',
      ogType: 'website',
      ogUrl: 'https://teba.oldmutualwill.co.za/articles',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Teba',
    },
  },
  sso: {
    googleSsoEnabled: false,
    googleClientId:
      '311768930697-alolgso3c0ip6n8npne6s30cf7vsknqg.apps.googleusercontent.com',
    facebookSsoEnabled: true,
    facebookAppId: '',
  },
  testamentaryTrustData: [
    {
      title: '<h2>Why Testamentary Trusts Are Important</h2>',
      content: `<p>A testamentary trust is created in your will and activates upon your death. It ensures that your assets 
      are managed according to your wishes, providing financial security for vulnerable beneficiaries like minor children or dependent family members.</p>`,
    },
    {
      title: '<h2>Who Should Consider Setting Up a Testamentary Trust?</h2>',
      content: `<p>If you have minor children, vulnerable family members, or want to ensure your loved ones' inheritance 
      is wisely managed, a testamentary trust is an essential tool in safeguarding their financial future.  
      Setting up a testamentary trust is particularly relevant if you are leaving more than R500 000 to your beneficiaries. </p>`,
    },
    {
      title: '<h2>Purpose and Benefits of a Testamentary Trust</h2>',
      content: `<p>In South Africa, minor children cannot receive inheritance directly. A testamentary trust ensures that their 
      inheritance is managed in their best interests, allowing you to control how and when funds are distributed to your loved ones.</p>`,
    },
    {
      title: '<h2>How Testamentary Trusts Are Established and Managed</h2>',
      content: `<p>A testamentary trust is created through instructions in your will. It only comes into effect after your death, 
      and it’s essential to ensure your will is legally valid to avoid nullifying the trust.</p>`,
    },
    {
      title: '<h2>Appointing a Trustee: What to Consider</h2>',
      content: `<p>The trustee manages the trust’s assets and must act in the best interest of the beneficiaries. 
      Consider appointing an independent trustee to avoid conflicts of interest, especially if the trustee is also the guardian of your children.</p>`,
    },
    {
      title:
        '<h2>Testamentary Trusts in the Old Mutual Will Creation Process</h2>',
      content: `<p>Old Mutual Will offers the option to set up a testamentary trust as part of the online will creation process. 
      This ensures your loved ones are protected in alignment with your wishes.</p>`,
    },
  ],
  executorData: [
    {
      title: '<h2>Understanding the Role of an Executor</h2>',
      content: `<p>An executor is responsible for managing your estate after your passing. Their duties include gathering information about 
      assets and liabilities, paying debts, managing assets, distributing inheritances, and resolving disputes. This role requires a deep understanding of legal and financial matters.</p>`,
    },
    {
      title: '<h2>Why Choosing the Right Executor is Crucial</h2>',
      content: `<p>Selecting the right executor for your estate is vital to ensure that your final wishes are carried out and your loved ones are cared for. 
      An executor needs to be trustworthy, competent, and experienced in estate administration to manage your estate effectively.</p>`,
    },
    {
      title: '<h2>Should You Appoint a Family Member or a Professional?</h2>',
      content: `<p>While appointing a family member may seem logical, estate administration requires expertise that most people lack. 
      The Master of the High Court may require a layperson to hire a professional representative. A professional executor, like Old Mutual, ensures that your estate is managed efficiently and in accordance with legal requirements.</p>`,
    },
    {
      title: '<h2>Executor Fees: What You Need to Know</h2>',
      content: `<p>Executor fees in South Africa are set at 3.5% of the gross value of the estate plus VAT. 
      Executors also charge 6% (plus VAT) of income generated during the administration period. It’s important to ensure that your estate has enough cash flow to cover these costs to avoid selling assets intended for beneficiaries.</p>`,
    },
    {
      title: '<h2>How Old Mutual Can Assist with Executor Services</h2>',
      content: `<p>Old Mutual offers professional executor services, bringing extensive experience in estate administration. 
      They can efficiently handle legal, financial, and administrative tasks, ensuring your estate is managed with care, allowing your family to focus on what matters most during a difficult time.</p>`,
    },
    {
      title:
        '<h2>Planning Ahead with Old Mutual’s Estate Administration Calculator</h2>',
      content: `<p>Old Mutual provides an estate administration costs calculator to help you estimate the costs involved in 
      administering your estate. This tool aids in planning to avoid unnecessary liquidation of assets, ensuring your beneficiaries receive what you intended. 
      Through the steps in this process we will provide you the opportunity to do a detailed cost calculation.</p>`,
    },
    {
      title: '<h2>The Importance of Professional Executor Services</h2>',
      content: `<p>Choosing a professional executor like Old Mutual ensures your estate is managed expertly, safeguarding your legacy 
      and providing peace of mind. Their expertise helps navigate the complexities of estate administration, ensuring your final wishes are honoured.</p>`,
    },
  ],
  livingWillData: [
    {
      title: '<h2>What Is a Living Will?</h2>',
      content: `<p>A Living Will is a legal document that specifies your medical treatment preferences if you become unable to make decisions 
      due to illness or incapacity. It ensures your healthcare choices are respected, even when you can’t communicate them.</p>`,
    },
    {
      title: '<h2>Importance of Creating a Living Will </h2>',
      content: `<p>Creating a Living Will is crucial for ensuring your end-of-life care aligns with your values and preferences. 
      Old Mutual Will offers a straightforward process for creating a Living Will, ensuring your wishes are legally documented and respected.</p>`,
    },
    {
      title: '<h2>Purpose of a Living Will in End-of-Life Planning</h2>',
      content: `<p>The main purpose of a Living Will is to outline your wishes regarding life-sustaining treatments, such as resuscitation or 
      artificial nutrition, in cases of terminal illness or permanent unconsciousness. It provides clear guidance on the medical interventions you do or do not want.</p>`,
    },
    {
      title: '<h2>Legal Standing of Living Wills in South Africa</h2>',
      content: `<p>In South Africa, Living Wills are recognised under common law, meaning they are generally respected by healthcare providers 
      despite not being governed by specific legislation. Clear and specific instructions in your Living Will help avoid ambiguity.</p>`,
    },
    {
      title:
        '<h2>Differences Between a Living Will and a Last Will and Testament</h2>',
      content: `<p>A Living Will specifies your medical treatment preferences if you become incapacitated, focusing on healthcare decisions. 
      A Last Will and Testament, on the other hand, deals with the distribution of your assets and guardianship of minors after your death.</p>`,
    },
    {
      title: '<h2>Why a Living Will Is Important in South Africa</h2>',
      content: `<p>Creating a Living Will is important for ensuring your medical treatment preferences are known, guiding healthcare providers, reducing family conflicts, 
      and bringing peace of mind. It also encourages open discussions about end-of-life care with loved ones.</p>`,
    },
    {
      title: '<h2>How to Create a Living Will in South Africa</h2>',
      content: `<p>To create a Living Will, reflect on your medical preferences, consult healthcare providers if needed.  
      You can then create your Living Will as part of the online process with Old Mutual’s online will creation service.</p>`,
    },
    {
      title: '<h2>Appointing a Healthcare Proxy in South Africa</h2>',
      content: `<p>A healthcare proxy is someone you designate to make medical decisions on your behalf if you’re incapacitated. Choose a responsible 
      person, document the appointment, and ensure they understand your preferences. Formalize this with a power of attorney for healthcare.</p>`,
    },
    {
      title:
        '<h2>Living Will vs. Living Trust: Understanding the Difference</h2>',
      content: `<p>A Living Will outlines your medical preferences if you’re incapacitated, while a Living Trust manages your assets during 
      your lifetime and after death. The Living Will focuses on healthcare, while the Living Trust handles financial matters.</p>`,
    },
    {
      title: '<h2>Living Will vs. Do Not Resuscitate (DNR) Orders</h2>',
      content: `<p>A Living Will covers various medical treatment preferences, including end-of-life care. A DNR order specifically 
      instructs healthcare providers not to perform CPR if your heart stops, focusing on one aspect of your overall medical care plan.</p>`,
    },
  ],
  omDesign: false,
};
